<template>
    <div class="box-content">
        <div class="d-flex">
            <button class="btn btn-pink-53 w140 mr-3 btn-up-img" @click="upload()">{{$t('button.ok')}}</button>
            <button class="btn btn-upload-img mr-3 w140 btn-up-img" @click="selectFiles" :style="{ 'display' : isCanOcr() ? 'none' : '' }">{{$t('button.add_file')}}</button>
            <button class="btn btn-gray-53 w140 btn-up-img" @click="cancelUpload()">{{$t('button.cancel')}}</button>
        </div>
        <div class="d-flex" style="margin-top: 0.5rem">
            <div class="bg-gray-btm mr-3 g-checkbox">
                <label v-for="s in ocrList" :key="s.id" class="radio-ocr">
                    <input type="radio" name="radioOCr" v-model="selectedOcr" :value="s.id" class="radioicon-ocr" @click="selectOcr(s.id)" :disabled="!isCanOcr()">
                    {{ s.name }}
                </label>
                <label class="checkbox-custom f-w-300">
                    <input type="checkbox" name="handwriteOcr" v-model="handwriteOcr" :disabled="!ocr"/>
                    <span class="checkmark" v-if="ocr"></span>
                    <i class="checkmark-disabled" v-else></i>
                    <span>{{$t('voucher.ocr.handwriting')}}</span>
                </label>
            </div>
        </div>
        <div class="info-dragAndDrop">ドラッグ＆ドロップでファイルの並び替えができます。</div>
        <div class="box-img">
            <draggable v-model="files">
                <a href="#" v-for="(file, index) in files" :key="index" class="preview lst-img" data-dismiss="modal" data-toggle="modal" @click="showThumb(file)" >
                    <div class="file-preview">
                        <div v-if="file.type === 'image/tiff'" :id="'tiff_' + index" class="thumb-tiff">{{loadImage(file.url,'tiff_' + index)}}</div>
                        <pdf v-if="file.type === 'application/pdf'" :src="file.url" class="thumb-pdf"></pdf>
                        <img v-if="file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg'" class="preview-upload" :src="file.url"/>
                    </div>
                    <span class="text-img">
                        <p class="fs-13 text-truncate">{{ file.name }}</p>
                    </span>
                </a>
                <!-- <div v-for="(file, index) in files" :key="index" class="item">
                    {{ file.name }}
                </div> -->
            </draggable>

            <!-- <a href="#" v-for="(file, index) in files" :key="index" class="preview lst-img" data-dismiss="modal" data-toggle="modal" @click="showThumb(file)" >
                <div class="file-preview">
                    <div v-if="file.type === 'image/tiff'" :id="'tiff_' + index" class="thumb-tiff">{{loadImage(file.url,'tiff_' + index)}}</div>
                    <pdf v-if="file.type === 'application/pdf'" :src="file.url" class="thumb-pdf"></pdf>
                    <img v-if="file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg'" class="preview-upload" :src="file.url"/>
                </div>
                <span class="text-img">
                    <p class="fs-13 text-truncate">{{ file.name }}</p>
                </span>
            </a> -->
        </div>
        <div class="d-flex">
            <button class="btn btn-pink-53 w140 mr-3 btn-up-img" @click="upload()">{{$t('button.ok')}}</button>
        </div>

    </div>

</template>
<script>
import Utils from "@/helpers/utils";
import VoucherManagementService from "@/services/module/voucher.service";
import {AuthService} from "@/services/common/auth.service";
import pdf from 'vue-pdf';
import Tiff from 'tiff.js';
import { Constants } from "@/helpers/constants";
import StorageService from "@/services/common/storage.service";
import exifr from 'exifr';
import draggable from 'vuedraggable'

export default {
    name: "PcPreviewFileUpload",
    props: {
        modeAddVoucher: Function,
        cancelUpload: Function,
        selectFiles: Function,
        showThumb: Function,
        setErrorMessage: Function,
        uploadFiles: "",
        voucherType: "",
    },
    components: {
        draggable: draggable,
        pdf: pdf,
    },
    data () {
        return {
            constants: Constants,
            files: [],
            handwriteOcr: 0,
            selectedOcr: "",
            imprintRemovalOcr: 0,
            ocrList: Constants.ocrList,
            ocr: false,
        };
    },
    beforeMount () {
    },
    methods: {
        isCanOcr() {
            if (!(this.voucherType == Constants.VoucherType.before_schedule.id || this.voucherType == Constants.VoucherType.before_items.id || this.voucherType == Constants.VoucherType.before_pamphlet.id || this.voucherType == Constants.VoucherType.before_bulk.id ||
            this.voucherType == Constants.VoucherType.after_schedule.id || this.voucherType == Constants.VoucherType.after_items.id || this.voucherType == Constants.VoucherType.after_bulk.id ||
            this.voucherType == Constants.VoucherType.confirm_schedule.id || this.voucherType == Constants.VoucherType.confirm_items.id || this.voucherType == Constants.VoucherType.confirm_bulk.id)) {
                return true;
            } else {
                this.selectedOcr = Constants.ocrList[1].id;
                this.ocr = false;
                return false;
            }
        },
        selectOcr (selectedId) {
            this.selectedOcr = selectedId;
            this.ocr = this.selectedOcr == this.ocrList[0].id;
        },
        upload () {
            this.setErrorMessage("");
            StorageService.saveOcr(this.selectedOcr);
            if (this.uploadFiles.length && this.voucherType) {
                this.getFormData().then(formD => {
                    return VoucherManagementService.upload(formD);
                })
                    .then(response => {
                        if (response.status == 423) {
                            StorageService.saveExpired();
                            AuthService.doLogout();
                        } else if (response.status != 200) {
                            let errorCode = Utils.getErrorCode(response);
                            let msg = this.$root.$t("fail.ocr_timeout");
                            if (errorCode) {
                                msg = this.$root.$t("error.error_code_" + errorCode);
                            }
                            this.$toasted.error(msg, {});
                            if (response.status != 409) {
                                this.modeAddVoucher();
                            }
                        } else {
                            if (response.data.message == "Ok") {
                                let msg = this.$root.$t("success.add_success");
                                this.$toasted.success(msg, {});
                            } else if (response.data.message == "Ng") {
                                let msg = this.$root.$t("fail.upload_ng");
                                this.$toasted.error(msg, {});
                            } else {
                                let msg = this.$root.$t("fail.ocr_timeout");
                                this.$toasted.error(msg, {});
                            }
                            this.modeAddVoucher(response.data);
                        }
                    })
                    .catch(error => {
                        this.setErrorMessage(
                            this.$root.$t("error.error_unknown")
                        );
                        let msg = this.$root.$t("error.error_unknown");
                        this.$toasted.error(msg, {});
                    });
            } else {
                let msg = this.$root.$t("error.error_unknown");
                this.$toasted.error(msg, {});
            }
        },

        async getFormData () {
            let formData = new FormData();
            let dateFile = [];

            for (var i = 0; i < this.uploadFiles.length; i++) {
                const prvFile = this.files[i];
                const id = prvFile.no * 1;
                let file = this.uploadFiles[id];
                formData.append('files', file);
                let exif = null;
                try {
                    exif = await this.getExif(file);
                } catch (error) {
                    //
                }
                if (exif) {
                    if (exif.DateTimeOriginal) {
                        dateFile.push(new Date(exif.DateTimeOriginal).getTime());
                    } else if (exif.CreateDate) {
                        dateFile.push(new Date(exif.CreateDate).getTime());
                    } else {
                        dateFile.push(this.uploadFiles[id].lastModified);
                    }
                } else {
                    dateFile.push(this.uploadFiles[id].lastModified);
                }
            }

            formData.append('oldest_date', Math.min.apply(null, dateFile));
            formData.append('ocr', this.ocr ? 1 : 0);
            formData.append('voucherType', this.voucherType);
            formData.append('handwriteOcr', (this.handwriteOcr && this.ocr) ? 1 : 0);
            formData.append('imprintRemovalOcr', (this.imprintRemovalOcr && this.ocr) ? 1 : 0);
            return formData;
        },

        async getExif (file) {
            return new Promise((resolve, reject) => {
                let binary = null;
                const reader = new FileReader();
                reader.onload = (e) => {
                    binary = e.target.result;
                    let output = exifr.parse(binary, true);
                    if (output) {
                        resolve(output);
                    }
                };
                reader.readAsDataURL(file);
            });
        },

        loadImage (filename, id) {
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'arraybuffer';
            xhr.open('GET', filename);
            xhr.onload = function (e) {
                var tiff = new Tiff({buffer: xhr.response});
                var width = '100';
                var height = '100';
                var canvas = tiff.toCanvas();
                if (canvas) {
                    canvas.setAttribute('style', 'max-width:' + (width) +
                    '%; max-height: ' + (height) + '%');
                    let img = document.getElementById(id);
                    img.innerHTML = "";
                    img.append(canvas);
                }
            };
            xhr.send();
        },

        showFiles() {
            let result = [];
            for(const file of this.files) {
                result.push(file.name);
            }
            alert(result);
        }
    },
    mounted () {
        if (this.uploadFiles) {
            for (let i = 0; i < this.uploadFiles.length; i++) {
                let reader = new FileReader();
                let _this = this;
                let name = this.uploadFiles[i].name;
                let type = this.uploadFiles[i].type;
                reader.onload = function (e) {
                    _this.files.push(
                        {
                            no: i,
                            url: e.target.result,
                            name: name,
                            type: type,
                        }
                    );
                };
                reader.readAsDataURL(this.uploadFiles[i]);
            }
        }

        let storageOcr = StorageService.getOcr();
        let tourInfo = JSON.parse(StorageService.getTour());
        if (tourInfo && tourInfo.tour_type == Constants.TourType.international.id) {
            this.selectedOcr = Constants.ocrList[1].id;
        } else if (Utils.isEmptyStr(storageOcr)) {
            if (!tourInfo) {
                this.selectedOcr = Constants.ocrList[1].id;
            } else {
                this.selectedOcr = Constants.ocrList[0].id;
            }
        } else {
            this.selectedOcr = storageOcr;
        }
        this.ocr = this.selectedOcr == Constants.ocrList[0].id;

        if (Utils.getTemplateId(this.voucherType) == Constants.VoucherType.invoice_invoice.templateId ||
            Utils.getTemplateId(this.voucherType) == Constants.VoucherType.invoice_bill.templateId ||
            Utils.getTemplateId(this.voucherType) == Constants.VoucherType.local_expense_voucher_receipt.templateId ||
            Utils.getTemplateId(this.voucherType) == Constants.VoucherType.receipt_carry_cash.templateId ||
            Utils.getTemplateId(this.voucherType) == Constants.VoucherType.receipt_local_placement_income.templateId) {
            this.imprintRemovalOcr = true;
        }

        if (Utils.getTemplateId(this.voucherType) == Constants.VoucherType.contract_travel.templateId ||
            Utils.getTemplateId(this.voucherType) == Constants.VoucherType.invoice_bill.templateId ||
            Utils.getTemplateId(this.voucherType) == Constants.VoucherType.local_expense_voucher_receipt.templateId ||
            Utils.getTemplateId(this.voucherType) == Constants.VoucherType.receipt_carry_cash.templateId ||
            Utils.getTemplateId(this.voucherType) == Constants.VoucherType.receipt_local_placement_income.templateId ||
            Utils.getTemplateId(this.voucherType) == Constants.VoucherType.contract_underwriting.templateId) {
            this.handwriteOcr = this.ocr;
        }

        if (this.voucherType == Constants.VoucherType.before_schedule.id) {
            this.ocr = false;
            this.selectedOcr = this.ocrList[1].id;
        }
    },
    watch: {
        selectedOcr: function () {
            if (!this.ocr) {
                this.handwriteOcr = false;
            } else {
                if (Utils.getTemplateId(this.voucherType) == Constants.VoucherType.contract_travel.templateId ||
                Utils.getTemplateId(this.voucherType) == Constants.VoucherType.invoice_bill.templateId ||
                Utils.getTemplateId(this.voucherType) == Constants.VoucherType.local_expense_voucher_receipt.templateId ||
                Utils.getTemplateId(this.voucherType) == Constants.VoucherType.receipt_carry_cash.templateId ||
                Utils.getTemplateId(this.voucherType) == Constants.VoucherType.receipt_local_placement_income.templateId ||
                Utils.getTemplateId(this.voucherType) == Constants.VoucherType.contract_underwriting.templateId) {
                    this.handwriteOcr = true;
                }
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/pc/Voucher/PreviewFileUpload.vue